export const LS_IS_JUST_SIGNED_IN_VALUE = '1';
export const LS_IS_JUST_SIGNED_IN_NAME = 'justSignedIn';

export const GA4_CONTEXT_QUERY_KEY = ['ga4Context'] as const;
